export default __webpack_public_path__ + "static/media/SWT1380.34I-35068_-23151_0.be345b4d.jpg";